<template>
    <div class="sc-message--system">
        <slot :message="data">
            <span v-html="messageText" style="word-break: break-all; max-width: 475px" />
            <span
                v-if="data.meta"
                class="sc-message--meta"
                style="color: darkcyan; font-weight: 600; font-size: smaller"
            >
                {{ data.meta }}</span
            >
        </slot>
    </div>
</template>

<script>
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";

export default {
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    computed: {
        messageText() {
            let escaped = htmlUnescape(this.data.text.trim());
            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });
            res = this.hallet(res);
            res = res.replace(/<p>&nbsp;<\/p>$/gi, "");
            return res;
        },
    },
    methods: {
        hallet(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
    },
};
</script>

<style scoped>
.sc-message--system {
    padding: 8px 20px;
    border-radius: 6px;
    font-size: 12px;
    line-height: 1.2;
    -webkit-font-smoothing: subpixel-antialiased;
    font-style: italic;
    color: var(--chat-bubble-text, #000000) !important;
    background-color: var(--chat-bubble-system-background) !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.sc-message--meta {
    display: none;
    font-size: xx-small;
    margin-bottom: 0px;
    margin-top: 5px;
    opacity: 0.5;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/SystemMessage.vue